/**
 * Leave the SPA for a URL on another origin.
 *
 * Kept as a module of its own so tests can `vi.mock('@/utils/externalNavigation')`;
 * `window.location` is not writable under jsdom.
 *
 * @param url - absolute URL to load in place of the current document
 */
export const navigateExternal = (url: string): void => {
  window.location.assign(url);
};
